import {
  customerSendEmail
} from '../../services/apis'
import {
  hasError,
  isServerResponseError,
} from '../common'

const sendMail = async (id, data) => {
  const response = await customerSendEmail(id, data)
  return isServerResponseError(response) || hasError(response)
    ? 'failed'
    : 'success'
}

export default sendMail
